export default __webpack_public_path__ + "static/media/Vambrace of the Sanguine Disciple.bb5cc77c.jpg";